<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules">
        <!-- <div class="otit">车辆添加</div> -->

        <div class="bainfo">
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" :class="c.className" />
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";

export default {
  mixins: [detailMixin, mixin],
  data() {
    return {
      viewMode: false,
      baseUrl: 'trailer',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/hang` },
        { name: "挂车管理", path: `/vehicle/hang` },
        { name: "挂车添加" },
      ],
      form: {
        trailer: undefined,
        ton: undefined,
        buytime: undefined,
      },
      rules: {
        trailer: [
          { required: true, message: "请填写挂车号", trigger: "blur" },
        ],
        ton: [
          { required: true, message: "请填写载货重量", trigger: "blur" },
        ],
        buytime: [
          { required: true, message: "请选择车辆购入时间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          params[key] = value;
        }
      }

      const opt = this.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'trailer',
      }
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .info_form {
  padding-top: 20px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form {

    /*padding-top: 20px;
		border-radius: 5px;
		box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
		background-color: #fff;*/
    .el-form-item {
      /*border-bottom: 1px solid #f2f6fc;*/
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.tit_label {
        padding: 49px 0 0 72px;
        font-size: 18px;
        color: #333;
        line-height: 40px;

        &::before {
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      .el-input {
        width: 300px;
      }

      /*.el-form-item__content > div {
        width: 300px;
      }*/
      .el-upload__tip {
        left: 107px;
        top: 2px;
        width: 180px;
      }

      .el-button--small {
        padding: 12px 21px;
        font-size: 14px;
      }
    }

    .subform::before {
      width: 110%;
      height: 10px;
      background: #f9f9f9;
      content: "";
      //margin-bottom: 20px;
    }
  }
}

.info_form .el-form .insurance {
  margin-bottom: 0;
}

.el-row {
  padding-bottom: 20px;
}

.instyle {
  display: inline-block;
}

.bainfo {
  padding-bottom: 20px;
}

/deep/ .el-form .el-form-item.remind .content {
  display: block;

  .left:nth-child(2) {
    margin-left: 180px;
    margin-top: 20px;
  }
}

/deep/ .self {
  >.el-form-item__label {
    float: none !important;
    display: block;
    margin: 39px 0 20px 112px;
    text-align: left;
    font-size: 18px;
    color: #333;
  }

  >.el-form-item__content {
    margin-left: 0 !important;
  }
}

.otit {
  margin: 29px 0 20px 72px;
  text-align: left;
  font-size: 18px;
  color: #333;
}

.el-col-8:nth-child(2) {
  margin-left: -54px;
}

.el-col-8:nth-child(3) {
  margin-left: -55px;
}

/deep/ .subform .el-row .el-col-8 .el-form-item:last-child {
  margin-bottom: 40px;
}

/deep/.el-icon-arrow-right:before {
  content: "";
}

/deep/ .breadcrumb .el-icon-arrow-right:before {
  content: "\e6e0";
}

.btns {
  margin: 40px 0 60px 180px;
}

/deep/ .subform .tit_label {
  margin: 19px 0 17px 72px;
}

@media screen and (min-width:1500px) and (max-width:1640px) {
  .instyle:nth-child(2) {
    margin-left: 35px;
  }

  .instyle:nth-child(3) {
    margin-right: 35px;
  }

  // .info_form .el-form .subform {
  //   margin-bottom: 0;
  //   padding-right: 0;
  // }
  .el-col-8:nth-child(2) {
    margin-left: -19px;
  }

  .el-col-8:nth-child(3) {
    margin-left: -20px;
  }

  /deep/ .el-col-16 {
    margin-left: -18px !important;
  }

  /deep/ .info_form .el-form .el-col-8 .el-form-item {
    padding-right: 0 !important;
  }

  /deep/ .el-form .el-form-item.remind .content .left {
    margin-right: 0;
  }
}
</style>
